import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-coupon_btn_navigation",
  "use": "icon-coupon_btn_navigation-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-coupon_btn_navigation\"><clipPath id=\"icon-coupon_btn_navigation_a\"><path d=\"m4 4h16v16h-16z\" /></clipPath><circle cx=\"12\" cy=\"12\" fill=\"#fff\" r=\"12\" /><g clip-path=\"url(#icon-coupon_btn_navigation_a)\"><path d=\"m11.613 18.793c-.029 0-.058-.002-.086-.004-.389-.037-.713-.315-.807-.694l-1.028-4.118-4.12-1.029c-.377-.093-.656-.417-.693-.805-.037-.389.176-.759.53-.923l11.34-5.76c.418-.212.924-.133 1.258.201.332.333.412.838.199 1.257l-5.771 11.366c-.139.303-.467.509-.822.509zm-.508-1.202c-.007.013-.014.026-.021.04zm-3.662-5.722 2.95.736c.328.079.586.336.669.669l.737 2.95 4.492-8.849zm2.584 2.191c.002.001.005.002.008.002zm-3.931-1.507-.034.017c.012-.005.023-.01.034-.017zm-.163-1.061h.003c-.001.001-.002 0-.003 0z\" fill=\"#1a1a1a\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coupon_btn_navigation.svg
// module id = YEaf
// module chunks = 87